import type { SVGProps } from "react";
export interface GridAltIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function GridAltIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: GridAltIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M18.625 19.875h1.25v-1.25h-1.25zm-14.5 0h1.25v-1.25h-1.25zm7.25-7.25h1.25v-1.25h-1.25zm7.25-7.25h1.25v-1.25h-1.25zm-14.5 0h1.25v-1.25h-1.25zm3.5 15.125c0 .898-.728 1.625-1.625 1.625H3.5A1.625 1.625 0 0 1 1.875 20.5V18c0-.897.727-1.624 1.625-1.625H6c.897 0 1.625.727 1.625 1.625zm14.5 0c0 .898-.727 1.625-1.625 1.625H18a1.625 1.625 0 0 1-1.625-1.625V18c0-.898.727-1.625 1.625-1.625h2.5c.898 0 1.625.728 1.625 1.625zm-7.25-7.25c0 .897-.728 1.626-1.626 1.626h-2.498a1.627 1.627 0 0 1-1.626-1.627v-2.498c0-.898.728-1.626 1.626-1.626h2.498c.898 0 1.627.728 1.627 1.626v2.498ZM7.626 6c0 .897-.728 1.625-1.625 1.625H3.5A1.625 1.625 0 0 1 1.875 6V3.5c0-.898.727-1.625 1.625-1.625H6c.897 0 1.624.727 1.625 1.625V6Zm14.5 0c0 .897-.727 1.624-1.625 1.625H18A1.624 1.624 0 0 1 16.375 6V3.5c0-.898.728-1.625 1.625-1.625h2.5c.898 0 1.625.727 1.625 1.625V6ZM11.374 19.875h1.252v-1.25h-1.252zm7.251-7.25h1.25v-1.25h-1.25zm-14.5 0h1.25v-1.25h-1.25zm7.25-7.25h1.25v-1.25h-1.25zm3.5 15.125c0 .898-.728 1.625-1.626 1.625h-2.498A1.626 1.626 0 0 1 9.125 20.5V18c0-.898.728-1.625 1.626-1.625h2.498c.898 0 1.627.727 1.627 1.625zm-7.25-7.25c0 .897-.728 1.626-1.625 1.626H3.5a1.626 1.626 0 0 1-1.625-1.627v-2.498c0-.898.727-1.626 1.625-1.626H6c.897 0 1.625.728 1.625 1.626v2.498Zm14.5 0c0 .897-.727 1.625-1.625 1.626H18a1.625 1.625 0 0 1-1.625-1.627v-2.498c0-.898.727-1.626 1.625-1.626h2.5c.898 0 1.625.728 1.625 1.626v2.498ZM14.875 6c0 .897-.728 1.625-1.626 1.625h-2.498A1.625 1.625 0 0 1 9.125 6V3.5c0-.898.728-1.625 1.626-1.625h2.498c.898 0 1.626.727 1.627 1.625z"
      />
    </svg>
  );
}
